import React from 'react';

import BlockComponent from './BlockComponent';
import blockDefinition from './definitions/logo.json';
import Partials from '../partials';

const propTypes = {
};

const defaultProps = {
};

class LogoBlock extends BlockComponent {

    render() {
        return (
            <div className="block-logo">
                <Partials.Link to={''}>
                    <img src="/img/placeholders/logo.png" alt="logo" />
                </Partials.Link>
            </div>
        );
    }
}

LogoBlock.propTypes = propTypes;
LogoBlock.defaultProps = defaultProps;
LogoBlock.blockDefinition = blockDefinition;

export default LogoBlock;



// WEBPACK FOOTER //
// ./components/blocks/Logo.jsx